import { generatePath, createSearchParams, redirect, defer } from 'react-router-dom'

const edit = (resource, id) => {
  return generatePath(`/${resource}/edit/${id}`)
}

const create = (resource) => {
  return generatePath(`/${resource}/create`)
}

const list = (resource) => {
  return generatePath(`/${resource}`)
}

const attachment = (resource, id) => {
  return generatePath(`/${resource}/${id}/attachments`)
}

const attachmentUpload = (resource, id) => {
  return generatePath(`/${resource}/${id}/attachments/upload`)
}

export const forceSearchParamsLoader = (opts = {}, loader) => {
  const { initial = { page: 1, per_page: 10 }, args = {} } = opts
  const url = new URL(args.request.url)
  const searchParams = url.searchParams

  if (!searchParams.get('page') || !searchParams.get('per_page')) {
    const newSearchParams = createSearchParams(initial)
    const redirectUrl = `${url.pathname}?${newSearchParams}`
    return redirect(redirectUrl)
  }

  return defer({
    promise: loader(searchParams)
  })
}

export { edit, create, list, attachment, attachmentUpload }
